import { FC } from 'react';
import styled from 'styled-components';

type OrderIndexProps = {
  index: number;
};

export const Wrapper = styled.div`
  position: absolute;
  top: 4px;
  right: 4px;
  width: 25px;
  z-index: 100;
  height: 24px;
  background: #f5f7fa;
  border-radius: 3px;
  font-size: 14px;
  line-height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #292a2b;
`;

const OrderIndex: FC<OrderIndexProps> = ({ index }) => <Wrapper>{index}</Wrapper>;

export default OrderIndex;
